
import SvgIcon from "Theme/SvgIcon"
import { ReactComponent as GrifballIcon } from "../fontello/icons/svg/ic_grifball.svg"


const Grifball = ({ ...props }) => (
  <SvgIcon
    component={GrifballIcon}
    viewBox="0 0 1000 1000"
    {...props}
  />
)


export default Grifball
